export const initSideGallery = () => {
  if (document.body.classList.contains("neos-backend")) return;

  // For each side gallery on page.
  document.querySelectorAll(".nodetype-content-sidegallery").forEach((sideGallery) => {
    const slider = sideGallery.querySelector(".slider");
    const icon = sideGallery.querySelector(".picture .icon");

    if (!slider || !icon) return;

    /**
     * Toggle the visibility of the Slider element
     *
     * @param hidden boolean
     */
    const toggleSlider = (hidden) => {
      // Prevent content scroll using overflow-hidden class on html element.
      document.documentElement.classList.toggle("overflow-hidden", !hidden);

      // Toggle slider visibility
      slider.classList.toggle("hidden", hidden);
    };

    // Icon on picture click action.
    icon.addEventListener("click", () => toggleSlider(false), { passive: true });

    // Close button on slider click action.
    slider.querySelector(".close")?.addEventListener("click", () => toggleSlider(true));

    // Key down listener.
    window.addEventListener(
      "keydown",
      (event) => {
        const callback = {
          Escape: () => toggleSlider(true),
          ArrowLeft: () => slider.querySelector('.ui [data-nav="bw"]')?.click(),
          ArrowRight: () => slider.querySelector('.ui [data-nav="fw"]')?.click(),
        }[event.key];

        callback?.();
      },
      { passive: true }
    );
  });
};
